import style from "./LessonAddedModal.module.css";
import React from "react";
import { useTranslation } from "react-i18next";
import closeIcon from "../../../../base/assets/icons/icons_close.png";
import approveIcon from "../../../../base/assets/icons/approve_icon.png";
interface LessonAddedPropsDI {
  onClose: () => void;
  title: string;
  text: string;
}

const LessonAddedModal: React.FC<LessonAddedPropsDI> = (props) => {
  const { t } = useTranslation();

  return (
    <div className={style.wrapper}>
      <img
        src={closeIcon}
        alt={t("Lesson-Added-Close-Popup-alt")}
        className={style.close}
        onClick={props.onClose}
      />
      <img
        src={approveIcon}
        alt={t("Lesson-Added-icon-alt")}
        className={style.approve}
      />
      <h2 className={style.title}>{props.title}</h2>
      <p className={style.text}>{props.text}</p>
    </div>
  );
};

export default LessonAddedModal;
